module.exports = __webpack_public_path__ + "static/media/FULLPRINTS.9ac77048.jpg";